export default "__VITE_ASSET__322cfdca__"